module.exports = __webpack_public_path__ + "img/OBUHaveOrder_05.8d4095a0.png";